import { render, staticRenderFns } from "./view-assinatura.vue?vue&type=template&id=03a7986f"
import script from "./view-assinatura.vue?vue&type=script&lang=js"
export * from "./view-assinatura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports